import { IPlayerSeasonStats } from "../types/types";
import { compareSeasonsDesc } from "../utils/seasonOrder";

export const normalizePlayerName = (name: string): string =>
  name
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "");

const PLAYER_NAME_GROUPS: { canonical: string; variants: string[]; labels: string[] }[] = [
  { canonical: "Koust1", variants: ["koust1", "kousti"], labels: ["Koust1", "Kousti"] },
  { canonical: "VL", variants: ["vl", "veealla", "veell"], labels: ["VL", "VLツ", "Vee Ällä"] },
  {
    canonical: "vuorineuvos",
    variants: ["vuorineuvos", "rauhantuomari"],
    labels: ["vuorineuvos", "Vuorineuvos", "Rauhantuomari"],
  },
  {
    canonical: "Karlos",
    variants: ["karlos", "menninkine", "menninkinen", "menninkaine", "menninkainen"],
    labels: ["Karlos", "menninkäine", "Menninkäinen"],
  },
  {
    canonical: "Euphoria",
    variants: ["euphoria", "pihla", "phila"],
    labels: ["Euphoria", "Pihla", "Phila"],
  },
  {
    canonical: "AAWEE",
    variants: ["aawee", "westikka"],
    labels: ["AAWEE", "Westikka"],
  },
  {
    canonical: "Merza",
    variants: ["merza", "merzapapi"],
    labels: ["Merza", "Merza Papi", "merzapapi"],
  },
];

export const playerNameLookupKeys = (name: string): string[] => {
  const n = normalizePlayerName(name);
  if (!n) return [];
  for (const group of PLAYER_NAME_GROUPS) {
    if (group.variants.includes(n)) return group.variants;
  }
  return [n];
};

export const findAllPlayerSeasonStats = (
  stats: IPlayerSeasonStats[],
  playerName: string,
  displayName?: string,
): IPlayerSeasonStats[] => {
  const targets = new Set(
    [playerName, displayName]
      .filter((n): n is string => Boolean(n?.trim()))
      .flatMap(playerNameLookupKeys),
  );

  return stats
    .filter((s: IPlayerSeasonStats) => {
      return targets.has(normalizePlayerName(s.playerName));
    })
    .sort((a: IPlayerSeasonStats, b: IPlayerSeasonStats) => compareSeasonsDesc(a.season, b.season));
};

export const playerLookupNames = (
  playerName: string,
  displayName?: string,
  sheetPlayerName?: string,
): string[] => {
  const seen = new Set<string>();
  const out: string[] = [];
  const add = (name: string) => {
    const trimmed = name.trim();
    if (!trimmed || seen.has(trimmed)) return;
    seen.add(trimmed);
    out.push(trimmed);
  };

  for (const raw of [sheetPlayerName, playerName, displayName]) {
    if (!raw?.trim()) continue;
    add(raw);
    const keys = playerNameLookupKeys(raw);
    for (const group of PLAYER_NAME_GROUPS) {
      if (group.variants.some((v) => keys.includes(v))) {
        for (const label of group.labels) add(label);
      }
    }
  }
  return out;
};
